import { createFileRoute } from "@tanstack/react-router";
import { CreateRoundScreen } from "@modules/rounds/views";
// From the types barrel, NOT the feature barrel — `validateSearch` runs during routing, before the
// lazily-split screen loads, so anything this file imports lands in the INITIAL bundle. Reaching
// through the feature barrel would pull `@tanstack/react-form` onto every page including login.
import {
  toBuilderView,
  type BuilderView,
} from "@modules/rounds/configuration/types";
import { requireSurface } from "./-guards";

interface CreateSearch {
  /**
   * Which builder step to open.
   *
   * In the URL for the same reason the setup route does it: a reload has to resume where the
   * administrator was, not restart at step 1. That matters more here than there — this route has no
   * round to reload FROM, so the step and the `sessionStorage` draft are together the only things
   * that survive a refresh.
   */
  step: BuilderView;
}

// /staff/rounds/create — the round-builder wizard.
//
// The trailing `_` on `staff_` opts this route OUT of the /staff layout: the design gives the
// builder its own full-width chrome (brand bar + language switcher, no sidebar), because a
// four-step wizard holding an in-memory draft should not offer a sidebar click that discards it.
//
// Escaping the layout also escapes the layout's guard, so this route runs the surface check
// itself — a screen that mutates round configuration must never be reachable without the
// `round_configuration` surface just because its parent was skipped.
export const Route = createFileRoute("/staff_/rounds/create")({
  // Hand-written rather than a Zod adapter, matching the setup route: one enum-ish value does not
  // justify pulling the zod-adapter question into the router.
  validateSearch: (search: Record<string, unknown>): CreateSearch => ({
    step: toBuilderView(search.step),
  }),
  beforeLoad: ({ context, location }) =>
    requireSurface(
      context.queryClient,
      "round_configuration",
      location.pathname
    ),
  component: CreateRoundScreen,
});
